const conf = {
  backendUrl: 'https://facesign-dev-api.web.app',
  isDev: true,
  apiKey: 'AIzaSyC9Yrb5KsOSLelGbl9ymc-90SsNZCPTkDI',
  authDomain: 'facesignai-dev.firebaseapp.com',
  projectId: 'facesignai-dev',
  storageBucket: 'facesignai-dev.appspot.com',
  messagingSenderId: '511529342332',
  appId: '1:511529342332:web:a48b075c56218f48a240f9',
  apiUrl: 'https://api.dev.facesign.ai',
  firebaseStorageId: 'facesignai-dev.appspot.com',
  socketServerUrl: 'sd.facesign.ai',
  // Server-side STT (slice 1a shadow): tee the mic PCM to the socket in addition
  // to the client's own Deepgram. The server only transcribes when its
  // SERVER_STT_SHADOW env is on, so this just controls the client uplink.
  streamAudioToServer: true,
  // Server-side STT (slice 1b): 'server' drives turn-taking (onSpeech/onFinalDetected)
  // from the server's sttInterim/sttFinal instead of the local transcriber.
  // 'client' = shadow only (local transcriber authoritative). Requires
  // streamAudioToServer + the server's SERVER_STT_SHADOW.
  transcriberLocation: 'server',
  // Server-side control migration (slice 2 shadow): forward the avatar's LiveKit
  // lifecycle (talking/idle) to the server so it can mirror avatar status and log
  // the turn-taking decision it WOULD make. Log-only on the server; the client
  // stays authoritative. Inert unless set (deployed confs omit it).
  reportAvatarState: true,
  // Server-owned turn controller (slice 3b): 'server' hands turn-taking + barge-in
  // to the socket — the server drives the turn off its own STT and pushes the
  // phrase (serverPhrase) + interrupt (avatarCancel); the client goes inert. Needs
  // streamAudioToServer + transcriberLocation='server' + reportAvatarState. Requires
  // the server's SERVER_TURN_SHADOW (controller enabled). 'client' = 3a shadow only.
  turnTakingLocation: 'server',
  // Server-side avatar provisioning (slice 5): 'server' asks the socket to mint
  // the LiveKit room + a HeyGen LiveAvatar LITE session and hand back only the
  // browser bootstrap; the client skips its own POST to api.liveavatar.com and
  // just room.connect + renders. Requires the socket's LIVEKIT_*/HEYGEN_LIVE_APIKEY
  // config. Omit or 'client' = legacy client-side FULL provisioning. NOTE: in LITE
  // the avatar has no voice until server-side TTS actuation (slice 6).
  sessionProvisioning: 'server'
}

module.exports = conf
